import { Injectable, OnDestroy } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import {
  showBasicAlert,
  SwalAlertTitles,
  SwalAlertTypes,
} from '../shared/tools/swal-alerts';
import { UsuarioMessages } from '../shared/messages/usuario';
import { UsuarioEmpresaService } from '../shared/services/usuario-empresa.service';
import { PathGuard } from '../shared/guard/path';
import { EmpresaGuardValidators } from '../shared/guard/empresa';

/**
 * Guardian para validar las empresas asignadas al usuario, en caso de no tener, se impide el acceso a la aplicación
 */
@Injectable({
  providedIn: 'root',
})
export class EmpresaGuard implements CanActivate, OnDestroy {
  constructor(
    private router: Router,
    private usuarioEmpresaService: UsuarioEmpresaService
  ) {}

  ngOnDestroy(): void {
    this.usuarioEmpresaService.ngOnDestroy();
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let acceso = true;
    let url: string = PathGuard.getPathValue(route, state);
    const isMain = PathGuard.getMainRoute(url);
    let redireccionar: string = PathGuard.getPathRedirectoTo(url, isMain);
    let mensaje: string = '';
    let error: boolean = false;

    mensaje = UsuarioMessages.getMsjUsuarioSinEmpresaAsignada('empresa');
    this.usuarioEmpresaService.obtenerEmpresasActualizadoLocal();
    acceso = this.usuarioEmpresaService.validarEmpresasAsignadas();

    if (acceso) {
      if (
        EmpresaGuardValidators.validarWMS(url) &&
        !this.usuarioEmpresaService.validarEmpresasAsignadasUsuarioTipo(true)
      ) {
        acceso = false;
        mensaje =
          UsuarioMessages.getMsjUsuarioSinEmpresaAsignada('empresa CEDIS');
      } else if (
        EmpresaGuardValidators.validarPuntoVenta(url) &&
        !this.usuarioEmpresaService.validarEmpresasAsignadasUsuarioTipo(false)
      ) {
        acceso = false;
        mensaje = UsuarioMessages.getMsjUsuarioSinEmpresaAsignada('Tienda');
      }
    }

    if (!acceso) {
      showBasicAlert(
        error ? SwalAlertTitles.ERROR : SwalAlertTitles.STOP,
        mensaje,
        error ? SwalAlertTypes.ERROR : SwalAlertTypes.WARNING,
        () => {
          this.router.navigateByUrl(redireccionar);
        }
      );
    }
    return acceso;
  }
}
